import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { URLS } from './const/nav'
import { Buffer } from 'buffer'

// Polyfill para process en el navegador
if (typeof window !== 'undefined') {
  window.process = window.process || require('process/browser')
  window.Buffer = Buffer
}

let apiUrl = window.location.origin
//apiUrl = apiUrl.replace('3000', '3005') // Quitar esta linea si se va a correr en produccion
URLS.BACKEND_URL = apiUrl + '/api'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
